/**
 * Rutas de Seguridad y Salud
 * Gestión de seguridad: riesgos, inspecciones, accidentes, capacitaciones, EPP, salud ocupacional
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import Riesgos from '../pages/seguridad/risks/Riesgos.jsx'
import InspeccionesSeguridad from '../pages/seguridad/inspections/InspeccionesSeguridad.jsx'
import Accidentes from '../pages/seguridad/accidents/Accidentes.jsx'
import Capacitaciones from '../pages/seguridad/trainings/Capacitaciones.jsx'
import EPP from '../pages/seguridad/ppe/EPP.jsx'
import SaludOcupacional from '../pages/seguridad/occupational-health/SaludOcupacional.jsx'

export const securityRoutes = [
  <Route 
    key="riesgos" 
    path="/riesgos" 
    element={
      <ProtectedRoute>
        <Riesgos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="inspecciones-seguridad" 
    path="/inspecciones-seguridad" 
    element={
      <ProtectedRoute>
        <InspeccionesSeguridad />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="accidentes" 
    path="/accidentes" 
    element={
      <ProtectedRoute>
        <Accidentes />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="capacitaciones" 
    path="/capacitaciones" 
    element={
      <ProtectedRoute>
        <Capacitaciones />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="epp" 
    path="/epp" 
    element={
      <ProtectedRoute>
        <EPP />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="salud-ocupacional" 
    path="/salud-ocupacional" 
    element={
      <ProtectedRoute>
        <SaludOcupacional />
      </ProtectedRoute>
    } 
  />,
]

